import React, { useEffect, useState, useRef } from 'react';
import classNames from 'classnames';
import Title from '../title/index.jsx';
import {
  textareaClassname,
  textareaWithError,
  textareaWithAction,
  actionWrapper,
  actionContainer,
  iconContainer,
  errorClassname,
  countContainer,
  countClassname,
} from './styles.js';

const Textarea = ({
  type = 'text',
  label = null,
  labelType = 'h6',
  error = null,
  action = null,
  useLocalValue = true,
  iconRight = null,
  style: overwriteStyles = {},
  rootStyle = {},
  autoFocus,
  maxLength,
  ...attr
}) => {
  const [focus, setFocus] = useState(false);
  const [localValue, setLocalValue] = useState(null);
  const [charCount, setCharCount] = useState(0);
  const className = classNames(
    textareaClassname,
    error && textareaWithError,
    action && textareaWithAction,
  );

  const { value, onFocus, onChange, onBlur } = attr;

  const handleFocus = (event) => {
    if (typeof onFocus === 'function') onFocus(event);
    setLocalValue(event.target.value);
    setFocus(true);
  };

  const handleChange = (event) => {
    if (typeof onChange === 'function') onChange(event);
    setLocalValue(event.target.value);
    if (maxLength) {
      setCharCount(event.target.value?.length);
    }
  };

  const handleBlur = (event) => {
    if (typeof onBlur === 'function') onBlur(event);
    setLocalValue(null);
    setFocus(false);
  };

  const ref = useRef(null);
  useEffect(() => {
    if (autoFocus) {
      if (ref.current) {
        ref.current.focus();
        // when focusing, also set the cursor to the end of the input
        // using localValue here doesn't work because it may not be set yet
        const valueLength = ref.current.value?.length;
        if (valueLength) {
          ref.current.setSelectionRange(valueLength, valueLength);
        }
      }
    }
  }, [autoFocus]);

  const textarea = (
    <>
      <textarea
        ref={ref}
        maxLength={maxLength}
        type={type}
        className={className}
        style={overwriteStyles}
        {...attr}
        onFocus={handleFocus}
        onChange={handleChange}
        onBlur={handleBlur}
      >
        {focus && useLocalValue ? localValue : value}
      </textarea>
      {maxLength && (
        <div className={countContainer}>
          <p className={countClassname}>
            {value ? value.length : charCount} / {maxLength}
          </p>
        </div>
      )}
    </>
  );

  return (
    <div style={rootStyle}>
      {label && <Title type={labelType}>{label}</Title>}
      {!!action && (
        <div className={actionWrapper}>
          {textarea}
          <div className={actionContainer}>{action}</div>
        </div>
      )}
      {!!iconRight && <div className={iconContainer}>{iconRight}</div>}
      {!action && textarea}
      {error && <p className={errorClassname}>{error}</p>}
    </div>
  );
};

export default Textarea;
